/* SVARAA — Welcome offer popup
   Shows a full-page overlay 5 seconds after page load for guest visitors.
   Logged-in users never see this (Liquid strips the HTML server-side).
   Uses sessionStorage so it shows once per browser session (reappears
   after closing the tab / new visit, but not on every page navigation). */
(function () {
  'use strict';

  var STORAGE_KEY = 'svaraa_popup_seen';
  var DELAY_MS = 5000;
  var CLOSE_ANIM_MS = 350;

  var FOCUSABLE = [
    'a[href]', 'button:not([disabled])', 'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])', 'textarea:not([disabled])', '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  var popup, lastFocus, timer;

  function wasDismissed() {
    try { return sessionStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return false; }
  }

  function markDismissed() {
    try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
  }

  function open() {
    if (!popup) return;
    lastFocus = document.activeElement;
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('svaraa-popup-open');
    requestAnimationFrame(function () {
      popup.classList.add('is-visible');
    });
    document.addEventListener('keydown', onKey);

    var closeBtn = popup.querySelector('.svaraa-popup__close');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 400);
  }

  function close() {
    if (!popup || popup.hidden) return;
    popup.classList.remove('is-visible');
    document.body.classList.remove('svaraa-popup-open');
    document.removeEventListener('keydown', onKey);
    markDismissed();

    setTimeout(function () {
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus(); } catch (e) {}
      }
    }, CLOSE_ANIM_MS);
  }

  function trapFocus(e) {
    if (e.key !== 'Tab' || !popup || popup.hidden) return;
    var els = popup.querySelectorAll(FOCUSABLE);
    if (!els.length) return;
    var first = els[0];
    var last = els[els.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
    else trapFocus(e);
  }

  function shouldShow() {
    if (wasDismissed()) return false;
    if (window.Shopify && Shopify.designMode) return false;
    return true;
  }

  function init() {
    popup = document.getElementById('SvaraaNewsletterPopup');
    if (!popup) return;

    popup.querySelectorAll('[data-svaraa-popup-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
    });

    var copyBtn = document.getElementById('SvaraaPopupCopyBtn');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = 'WELCOME5';
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(onCopied).catch(fallbackCopy);
        } else {
          fallbackCopy();
        }
        function fallbackCopy() {
          var ta = document.createElement('textarea');
          ta.value = code; ta.style.position = 'fixed'; ta.style.opacity = '0';
          document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); onCopied(); } catch (e) {}
          document.body.removeChild(ta);
        }
        function onCopied() {
          var label = copyBtn.querySelector('.svaraa-popup__code-copy-label');
          copyBtn.classList.add('is-copied');
          if (label) label.textContent = label.getAttribute('data-copied') || 'Copied!';
          setTimeout(function () {
            copyBtn.classList.remove('is-copied');
            if (label) label.textContent = label.getAttribute('data-default') || 'Copy';
          }, 2000);
        }
      });
    }

    if (!shouldShow()) return;
    timer = setTimeout(open, DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.SvaraaNewsletterPopup = { open: open, close: close };
})();
